import React from 'react';
import { useSignUpFlowContext } from '../SignUpFlowContext';

import ClientAgreement from '../../../../../Pages/ClientAgreement';
import WebsiteAgreement from '../../../../../Pages/WebsiteAgreement';
import SubscriptionSetup from '../../../../../Pages/SubscriptionSetup';
import SignUpFlowCompleted from './SignUpFlowCompleted';

const STEP_MAP = {
  websiteAgreement: WebsiteAgreement,
  signUp: ClientAgreement,
  signUpPayment: SubscriptionSetup,
};

const SignUpFlowPicker = () => {
  const { activeStep } = useSignUpFlowContext();
  const Component = STEP_MAP[activeStep?.attr('name')] || SignUpFlowCompleted;

  return (
    <Component />
  );
};

export default SignUpFlowPicker;
